import { useState } from "react";

// controllers
import { ProductController } from "controllers";

// helpers
import { swapItem } from "../../helper";

// components
import { Button } from "shared/components/bulma/button";
import { ProductSearchInput } from "shared/components/product";
import { Modal, ModalContent, ModalControl } from "shared/components/bulma/modal";
import { CardFooter } from "shared/components/bulma/card";
import { CardFooterItem } from "shared/components/bulma/card";

import Placeholder from "assets/placeholder-vertical.jpg";

const Item = ({ item, replacement = false }) => {

    const Icon = () => {
        if (replacement) {
            const color = item.barcode ? 'has-text-success' : '';
            return (
                <span className="icon-text">
                    <span className="icon">
                        <i className={`fas fa-check-circle ${color}`}></i>
                    </span>
                    <span>With</span>
                </span>
            );
        }

        return (
            <span className="icon-text">
                <span className="icon">
                    <i className="fas fa-times-circle has-text-danger"></i>
                </span>
                <span>Removing</span>
            </span>
        );
    }

    return (
        <div key={item.id}>
            <div className="card-image">
                <figure className="image">
                    <img src={item.imageURL} alt={item.barcode} />
                </figure>
            </div>
            <CardFooter>
                <CardFooterItem>
                    <Icon />
                </CardFooterItem>
            </CardFooter>
        </div>
    );
};

const SwapModal = ({ item, isActive, onDismiss, onConfirm }) => {
    const newItemInitial = { imageURL: Placeholder };

    const [product, setProduct] = useState(null);
    const [newItem, setNewItem] = useState(newItemInitial);

    const handleChange = async (event) => {
        const { value } = event.target;

        if (value) {
            const p = await ProductController.getProductByBarcode(value);
            const { barcode, imageURLs } = p;
            setNewItem({ barcode, imageURL: imageURLs[0] });
            setProduct(p);
        } else {
            setNewItem(newItemInitial);
        }
    }

    const handleConfirm = () => {
        if (onConfirm) { onConfirm(product) };
    }

    const SubmitButton = () => {
        if (newItem.barcode) {
            return <Button onClick={handleConfirm} className="is-primary">Swap</Button>
        }

        return null;
    }

    return (
        <Modal title={`Replace: ${item.barcode} - ${item.name}`} isActive={isActive}>
            <ModalContent>

                <ProductSearchInput
                    placeholder="Type to search for an available product"
                    status="available" onChange={handleChange} />

                <div className="columns is-vcentered">
                    <div className="column">
                        <Item item={item} />
                    </div>
                    <div className="column is-1">
                        <span className="icon is-size-1">
                            <i className="fas fa-exchange-alt"></i>
                        </span>
                    </div>
                    <div className="column">
                        <Item item={newItem} replacement={true} />
                    </div>
                </div>
            </ModalContent>
            <ModalControl>
                <SubmitButton />
                <Button onClick={onDismiss}>Cancel</Button>
            </ModalControl>
        </Modal>
    );
}

const SwapItemButton = ({ customer, box, item, onSwap }) => {

    const [isActive, setActive] = useState(false);

    const handleClick = async () => {
        setActive(true);
    }

    const dismiss = () => {
        setActive(false);
    }

    const swap = async (product) => {
        setActive(false);

        const newItem = await swapItem(product, customer, box, item);
        if (onSwap) { onSwap(newItem); }
    }

    const Modal = () => {
        if (!isActive) {
            return null;
        }

        return <SwapModal item={item} isActive={true} onConfirm={swap} onDismiss={dismiss} />
    }

    return (
        <>
            <small>
                <span className="icon-text is-clickable" onClick={handleClick}>
                    <span className="icon">
                        <i className="fas fa-exchange-alt"></i>
                    </span>
                    <span className="is-hidden-mobile">Swap</span>
                </span>
            </small>

            <Modal />
        </>
    );
}

export { SwapItemButton };
